/* eslint-disable @angular-eslint/component-selector */
import { Component, inject, OnInit, signal } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { LocalStorageService } from '@selfCareCore/storage/local-storage.service';
import { LOCAL_STORAGE_KEYS, SESSION_STORAGE_KEY } from '@selfCareCore/storage/storage.constant';
import { CommonService } from '@selfCareShared/services/common.service';
import { SharedDataService } from '@selfCareShared/services/shared-data.service';
import { filter, take } from 'rxjs';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  readonly activatedLoading = signal<boolean>(false);
  private readonly router = inject(Router);
  private readonly storage = inject(LocalStorageService);
  private readonly sharedDataService = inject(SharedDataService);
  private readonly commonService = inject(CommonService);

  ngOnInit(): void {
    // Defer until the first navigation completes so this does not race with deep links
    // (for example returning from an external payment gateway to /recharge/callback).
    // Accept both JSON boolean true and JSON string "true" because the value may be stored either way.
    this.router.events
      .pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        take(1)
      )
      .subscribe(() => {
        if (this.isOnboardingDone() || this.isAuthenticated()) {
          return;
        }
        const path = this.router.url.split('?')[0];
        if (path === '/onboarding') {
          return;
        }
        void this.router.navigate(['/onboarding'], { replaceUrl: true });
      });
    this.commonService
      .fetchfeatureVisibility()
      .pipe(take(1))
      .subscribe({
        next: (res) => {
          this.sharedDataService.setFeatureVisibility(res);
        },
        error: (err) => {
          console.error(err);
        },
      });
  }

  private isAuthenticated(): boolean {
    return !!this.storage.getItem(SESSION_STORAGE_KEY.ACCESS_TOKEN);
  }

  private isOnboardingDone(): boolean {
    try {
      const raw = this.storage.getItem(LOCAL_STORAGE_KEYS.IS_ONBOARDING_DONE);
      if (raw === null || raw === '') {
        return false;
      }
      const parsed: unknown = JSON.parse(raw);
      return parsed === true || parsed === 'true';
    } catch {
      return false;
    }
  }

  onActivate($event: any): void {
    this.activatedLoading.set(true);
    setTimeout(() => {
      this.activatedLoading.set(false);
    }, 1000);
  }
}
